import React from 'react'

import IngredientPage from '../../src/views/IngredientPage'
import {
  serverSideRequest,
  MongoDB,
  serializeObject,
  formatRecipe,
} from '../../src/helpers'

// We revalidate the page:
// - every 2 minutes in development environment
// - every 4 hours in production environment
const revalidate =
  process.env.NEXT_PUBLIC_API_ENV === 'development' ? 2 * 60 : 4 * 60 * 60

export async function getStaticPaths() {
  const defaultLocale =
    process.env.NEXT_PUBLIC_AVAILABILITY_ZONE === 'US' ? 'en' : 'fr'
  const { data: ingredients } = await serverSideRequest({
    name: 'getAllIngredients',
    availabilityZoneId: process.env.NEXT_PUBLIC_AVAILABILITY_ZONE,
    locale: defaultLocale,
    language: defaultLocale,
  })

  const paths = ingredients.map((ingredient) => {
    return {
      params: {
        ingredientId: ingredient._id || ingredient.id,
      },
      locale: process.env.NEXT_PUBLIC_AVAILABILITY_ZONE === 'US' ? 'en' : 'fr',
    }
  })

  return {
    paths:
      process.env.NEXT_PUBLIC_API_ENV === 'development'
        ? paths.slice(0, 8)
        : paths,
    fallback: 'blocking',
  }
}

export async function getStaticProps({ params, locale }) {
  if (!MongoDB.ObjectID.isValid(params.ingredientId)) {
    return {
      notFound: true,
      revalidate,
    }
  }

  const { data: ingredient } = await serverSideRequest({
    name: 'getIngredient',
    availabilityZoneId: process.env.NEXT_PUBLIC_AVAILABILITY_ZONE,
    ingredientId: params.ingredientId,
    start: 0,
    limit: 16,
    locale,
    language: locale,
    withRecipes: true,
  })

  if (!ingredient) {
    return {
      notFound: true,
      revalidate,
    }
  }

  return {
    props: serializeObject({
      ingredient: {
        editorialData: ingredient.editorialData || [],
        id: ingredient.id || '',
        imageUrl: ingredient.imageUrl || '',
        name: ingredient.name || '',
      },
      recipes: (
        ingredient.recipes.filter((ing) => !!ing.slugs[locale]) || []
      ).map((recipe) => formatRecipe(recipe, 'minimalist')),
    }),
    revalidate,
  }
}

const Ingredient = ({ ingredient, recipes }) => {
  return <IngredientPage ingredient={ingredient} recipes={recipes} />
}

export default Ingredient
